import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { NavItem } from '../types';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = (): void => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 检查是否在首页、入驻流程页、关于我们页、隐私政策页、服务条款页
  const isHomeOrJoinOrAboutOrLegal =
    location.pathname === '/' ||
    location.pathname === '/join' ||
    location.pathname === '/about' ||
    location.pathname === '/privacy' ||
    location.pathname === '/terms';

  // 这些页面：滚动后才显示阴影；其他页面始终有阴影
  const shouldUseScrolledStyle = isHomeOrJoinOrAboutOrLegal ? isScrolled : true;

  const navItems: NavItem[] = [
    { name: '首页', path: '/' },
    { name: '入驻流程', path: '/join' },
    { name: '关于我们', path: '/about' },
  ];

  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
      shouldUseScrolledStyle ? 'bg-white/95 backdrop-blur shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
          <img
            src="https://fbb.obs.cn-east-3.myhuaweicloud.com/png/20250714162711_HVuhvw.png"
            alt="Logo"
            className="w-8 h-8 rounded-lg object-cover"
          />
            <span className="font-bold text-xl text-gray-900">
              服帮帮
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`font-medium transition-colors ${
                  location.pathname === item.path
                    ? 'text-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden transition-colors text-gray-900"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar; 